import type { Task, TaskPriority } from '../../store/slices/tasks';
import { parseTaskId, taskStatusKey } from './taskUtils';

export interface TaskFilters {
  searchQuery: string;
  statuses: string[];
  priorities: TaskPriority[];
  assigneeIds: number[];
  assigneeRoles: string[];
  customerIds: number[];
}

const matchesSelection = <T extends string | number>(value: T | undefined, selected: T[]) =>
  selected.length === 0 || (value !== undefined && selected.includes(value));

export const taskMatchesFilters = (task: Task, filters: TaskFilters, assigneeRole: string) => {
  const query = filters.searchQuery.trim().toLowerCase();
  return (
    (filters.statuses.length === 0 ||
      filters.statuses.some((status) => taskStatusKey(status) === taskStatusKey(task.status))) &&
    matchesSelection(task.priority, filters.priorities) &&
    matchesSelection(parseTaskId(task.person_id_assign), filters.assigneeIds) &&
    matchesSelection(assigneeRole, filters.assigneeRoles) &&
    matchesSelection(parseTaskId(task.customer_id), filters.customerIds) &&
    (!query ||
      [
        task.task_id,
        `ECO-${task.task_id ?? ''}`,
        task.title,
        task.customer_id,
        task.person_name_assign,
      ].some((value) => value != null && String(value).toLowerCase().includes(query)))
  );
};
